import { Box, FormControl, FormControlLabel, Grid2, IconButton, Modal, Radio, RadioGroup, Snackbar, Typography } from '@mui/material';
import TokenError from '../tokenError.jsx';
import { useEffect, useState } from 'react';
import altProfile from '../../assets/images/altProfile.png';
import starIcon from '../../assets/icons/starIcon.png';
import verifiedTick from '../../assets/images/verifiedTick.png';
import rejectedCross from '../../assets/images/rejectedCross.png';
import Button from '@mui/material/Button';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useLocation, useNavigate } from 'react-router-dom';
import defaultImg from '../../assets/images/defaultimg.png';
import VisibilityIcon from '@mui/icons-material/Visibility';
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import axios from 'axios';

const CustomerDetails = () => {
    const location = useLocation();
    const serverUrl = config.serverUrl;
    const navigate = useNavigate();
    const operationsUrl = config.operationsUrl;
    const [tokenExpired, setTokenExpired] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [userImage, setUserImage] = useState('');
    const [userName, setUserName] = useState('');
    const [userRating, setUserRating] = useState('');
    const [userId, setUserId] = useState('');
    const [userPhone, setUserPhone] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userDob, setUserDob] = useState('');
    const [documentsData, setDocumentsData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [carDetailsData, setCarDetailsData] = useState([]);
    const [rejectModal, setRejectModal] = useState(false);
    const [rejectValue, setRejectValue] = useState('');
    const [customReason, setCustomReason] = useState('');
    const [modalData, setModalData] = useState({ vehicleId: null, documentId: null, status: 3, reason: '' });
    const [open, setOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);
    const clientdataShown = localStorage.getItem('hideuserinfo');

    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');

    useEffect(() => {
        if (location.state?.rowData) {
            const rowData = location.state?.rowData;
            console.log('location.state?.rowData=', rowData);
            setUserId(rowData.user_id);
            setUserEmail(rowData.user_email);
            setUserImage(rowData.user_image || '');
            setUserRating(rowData.rating);
            setUserPhone(rowData.phone_number);
            setUserDob(rowData.date_of_birth);
            setUserName(rowData.user_name);
        }
    }, [location.state]);

    const handleImageOpen = (image) => {
        setCurrentImage(image);
        setOpen(true);
    };

    const handleImageClose = () => {
        setOpen(false);
        setCurrentImage(null);
    };

    const handleRejectChange = (event) => {
        setRejectValue(event.target.value);
    };

    useEffect(() => {
        if(userId){
            fetchDocuments();
        }
    }, [userId]);

    const handleTextAreaChange = (event) => {
        setCustomReason(event.target.value);
    };

    const fetchDocuments = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/get_details`;
            const obj={
                token: token, timestamp: timestamp, user_id: userId,
            }

            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag == 200){
                const driversData = response.data;
                console.log('driversData.vehicle_details = ', driversData.user_documents)
                setDocumentsData(driversData.user_documents);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleRejectModal = (documentId, vehicleId, status, docType) => {
        setModalData({ documentId, vehicleId, status, docType});
        setRejectModal(true);
    };

    // Close reject modal
    const onClose = () => {
        setRejectModal(false);
        setRejectValue('');
        setCustomReason('');
    };

    const handleRejectSubmit = async (documentId, vehicleId, status, docType) => {

        try {
            const token = localStorage.getItem('token');
            const finalReason = customReason || rejectValue;
    
            // Check if it's a vehicle or driver document
            if (docType === 'driver') {
                const response = await axios.post(operationsUrl + '/panel/documents/verify', {
                    token: token,
                    user_id: userId,           // Use the driver's ID
                    document_id: documentId,       // Pass document ID
                    status: status,                // Pass the status (1 = approve, 3 = reject)
                    reason: finalReason,           // Only include reason if it's a reject
                });
                if(response.data.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
                if (response.data.flag === 200) {
                    fetchDocuments();
                }
            }
        } catch (error) {
            console.error('Error handling approve/reject:', error);
        }
    };

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            <div style={{minHeight: '100vh'}}>
                        
                <Typography style={{ fontSize: '28px', fontWeight: '500' }}>User</Typography>
                <Typography style={{ color: '#83888E'}}>User / Customer / Customer Details</Typography>

                <Grid2 className="mainBox">
                    <Grid2 container className="innerOne" size={12}>
                        <Grid2 item size={2} sx={{margin:'20px'}}>
                            <Box sx={{display:'flex'}}>
                                <Grid2>
                                    <Box sx={{ position: 'relative' }}>
                                        {userImage && (
                                            <img className="profileBox" src={userImage} alt="profile" width='80px' height='80px'/>
                                        )}
                                        {userImage=="" && (
                                            <img className="profileBox" src={altProfile} alt="alt profile" width='80px' height='80px'/>
                                        )}
                                    </Box>
                                </Grid2>
                                
                            </Box>
                            <Typography sx={{mt:'4px'}}>{userName}</Typography>
                            <Typography sx={{mt:'4px'}}>
                                {[...Array(5)]?.map((_, index) => (
                                    <span key={index}>
                                        {index < parseFloat(userRating).toFixed(2) ? 
                                        <img src={starIcon} height="12px" width="12px" style={{marginRight:'1%'}} />
                                            : ' '}
                                    </span>
                                ))}
                            </Typography>
                        </Grid2>
                        <Grid2 item size={9.5} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', marginBottom:'20px' }}>

                            <Grid2 container item spacing={5}  sx={{ justifyContent:'right',}}>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>User ID</Grid2>
                                    <Grid2 item className='detailsText'>{userId}</Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Mobile Number</Grid2>
                                    <Grid2 item className='detailsText'>{clientdataShown == '1' ? (() => {
                                        if (!userPhone) return '****';
                                        const phone = userPhone;
                                        // Remove any non-digit characters for processing
                                        const cleanPhone = phone.replace(/\D/g, '');
                                        if (cleanPhone.length <= 4) return '****';
                                        const firstTwo = cleanPhone.substring(0, 2);
                                        const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                        const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                        return "+" + firstTwo + maskedMiddle + lastTwo;
                                    })() : userPhone}</Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Email</Grid2>
                                    <Grid2 item className='detailsText'>{clientdataShown == '1' ? (() => {
                                                if (!userEmail) return '****';
                                                const email = userEmail;
                                                const atIndex = email.indexOf('@');
                                                if (atIndex <= 2) return '**' + email.substring(atIndex);
                                                const firstTwo = email.substring(0, 2);
                                                const domain = email.substring(atIndex);
                                                const maskedMiddle = '*'.repeat(atIndex - 2);
                                                return firstTwo + maskedMiddle + domain;
                                            })() : userEmail}</Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Date of birth</Grid2>
                                        <Grid2 item className='detailsText'>{dayjs(userDob).isValid() ? dayjs(userDob).format('DD-MM-YYYY') : '-'}</Grid2>
                                    </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>User City</Grid2>
                                    <Grid2 item className='detailsText'>{(clientCities.find(city => city.city_id === location.state?.rowData.city_id)) ? (clientCities.find(city => city.city_id === location.state?.rowData.city_id)).city_name : '--'}</Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 item className='detailsHead'>Registered Date</Grid2>
                                    <Grid2 item className='detailsText'>{location.state?.rowData.registered_date ? (date_format_dd_mm_yy == '1' ? dayjs(location.state?.rowData.registered_date).format('DD-MM-YYYY') : dayjs(location.state?.rowData.registered_date).format('YYYY-MM-DD')) : '-'}</Grid2>
                                </Grid2>
                            </Grid2>

                        </Grid2>
                    </Grid2>

                    <Grid2 container sx={{mt:'2%'}}>
                        <Box sx={{ width: '100%' }}>
                            <Grid2 container className="innerTwo" sx={{padding:'12px', marginTop:'2%'}}>
                                <Grid2 item sx={{backgroundColor:'#F9F9F9', width:'100%', padding:'1%', borderRadius:'8px'}}>
                                    <Typography>Profile Picture</Typography>
                                </Grid2>
                                
                                <Grid2 item size={9.5} sx={{marginLeft:'2%'}}>
                                    <Grid2 item container>
                                        <Grid2 item size={2} sx={{marginTop:'1%'}}>
                                            <Box height='102px' width='102px' sx={{borderRadius:'12px'}}>
                                                {userImage && (
                                                    <img src={userImage} alt="profile" width='100px' height='100px'/>
                                                )}
                                                {userImage=="" && (
                                                    <img src={altProfile} alt="alt profile" width='100px' height='100px'/>
                                                )}
                                            </Box>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>
                            </Grid2>

                            <Grid2 container className="innerTwo" sx={{ padding: '12px', marginTop: '2%' }}>
                                <Grid2 item sx={{ backgroundColor: '#F9F9F9', width: '100%', padding: '1%', borderRadius: '8px' }}>
                                    <Typography>Documents</Typography>
                                </Grid2>

                                <Grid2 item size={11.5} sx={{ marginLeft: '2%', mb: '2%' }}>
                                    {documentsData?.map((doc, index) => (
                                        <Grid2 container sx={{ padding: '12px', marginTop: '2%' }} key={`driver-doc-${doc.document_id}-${index}`}>
                                            <Grid2 item sx={{ backgroundColor: '#F9F9F9', width: '100%', padding: '1%', borderRadius: '8px', display: 'flex' }}>
                                                <Typography>{doc.document_name}</Typography>
                                                <Grid2 item sx={{marginLeft:'auto'}}>
                                                    <Typography sx={{color:'#0065FF', border:'1px solid #D1D5DB', borderRadius:'6px', padding:'3px 8px'}}>{doc.document_number}</Typography>
                                                </Grid2>
                                            </Grid2>

                                            <Grid2 item size={9.5} sx={{ marginLeft: '2%', mb: '2%' }}>
                                                <Grid2 container spacing={10}>
                                                    {(doc.images.split(';;;;'))?.map((image, imageIndex) => (
                                                        <Grid2 
                                                            item 
                                                            size={2} 
                                                            sx={{ marginTop: '1%', textAlign: 'center' }} 
                                                            key={`driver-doc-${doc.document_id}-${imageIndex}`}
                                                        >
                                                            <Box 
                                                                height='102px' 
                                                                width='102px' 
                                                                sx={{ 
                                                                    borderRadius: '12px', 
                                                                    overflow: 'hidden', 
                                                                    border: '2px solid #0065FF', 
                                                                    display: 'flex', 
                                                                    justifyContent: 'center', 
                                                                    alignItems: 'center',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                {image ? (
                                                                    <img src={image} alt={`doc image ${imageIndex}`} width='100%' height='100%' />
                                                                ) : (
                                                                    <img src={defaultImg} alt="default image" width='100%' height='100%' />
                                                                )}
                                                            </Box>

                                                            <Grid2>
                                                                <VisibilityIcon sx={{
                                                                    cursor: 'pointer',marginTop: '8px',
                                                                    color: '#0065FF',fontSize: '24px'
                                                                    }} 
                                                                    onClick={() => handleImageOpen(image || defaultImg)}
                                                                />
                                                                <Typography sx={{ marginTop: '4px', fontSize: '12px', color: '#83888E' }}>
                                                                    {imageIndex === 0 ? 'Front' : 'Back'}
                                                                </Typography>
                                                            </Grid2>
                                                            
                                                        </Grid2>
                                                    ))}

                                                    {/* Modal for Image */}
                                                    <Modal open={open} onClose={handleImageClose}
                                                        sx={{display: 'flex',justifyContent: 'center',alignItems: 'center'}}>

                                                        <Box
                                                            sx={{
                                                                position: 'relative', width: '90vw', height: '90vh',
                                                                maxWidth: '500px', maxHeight: '500px', borderRadius: '12px',
                                                                overflow: 'hidden', backgroundColor: 'white',
                                                                display: 'flex',justifyContent: 'center', alignItems: 'center'
                                                            }}
                                                        >
                                                            <img
                                                                src={currentImage}
                                                                alt="Magnified Document"
                                                                style={{maxWidth:'100%', maxHeight:'100%', objectFit:'contain'}}
                                                            />
                                                        </Box>
                                                    </Modal>

                                                    {/* Document status and reject/approve buttons */}
                                                    <Grid2 item size={7} sx={{ marginTop: '3%', marginLeft:'8%' }}>
                                                        {doc.status === 1 && (
                                                            <Grid2 item>
                                                                <Grid2 item sx={{ marginBottom: '2%'}}>
                                                                    <img src={verifiedTick} width="36px" height="36px" alt="verified tick"/>
                                                                </Grid2>
                                                                <Grid2 item>
                                                                    <Typography sx={{ color: '#0DBA78', fontSize: '14px' }}>{doc.document_name} Approved</Typography>
                                                                </Grid2>
                                                            </Grid2>
                                                        )}

                                                        {doc.status === 3 && (
                                                            <Grid2 item>
                                                            <Grid2 item sx={{marginBottom: '2%'}}>
                                                                <img src={rejectedCross} width="36px" height="36px" alt="rejected cross"/>
                                                            </Grid2>
                                                            <Grid2 item>
                                                                <Typography sx={{ color: '#C71F1F', fontSize: '14px' }}>{doc.document_name} Rejected</Typography>
                                                                <Typography sx={{ color: '#83888E', fontSize: '14px' }}> (  {doc.reason}  )</Typography>
                                                            </Grid2>
                                                        </Grid2>
                                                        )}

                                                        {doc.status === 2 && (
                                                            <Grid2 container sx={{ gap: '8px', display: 'flex', marginTop:'4%' }}>
                                                                <Grid2 item>
                                                                    <Button
                                                                        variant="contained"
                                                                        sx={{ backgroundColor: '#0DBA78', width: '120px' }}
                                                                        onClick={() => handleRejectSubmit(doc.document_id, null, 1, 'driver')} // Directly approve here
                                                                    >
                                                                        Approve
                                                                    </Button>
                                                                </Grid2>
                                                                <Grid2 item>
                                                                    <Button
                                                                        variant="contained"
                                                                        sx={{ backgroundColor: '#C71F1F', width: '120px' }}
                                                                        onClick={() => handleRejectModal(doc.document_id, null, 3, 'driver')}
                                                                    >
                                                                        Reject
                                                                    </Button>
                                                                </Grid2>
                                                            </Grid2>
                                                        )}
                                                    </Grid2>
                                                </Grid2>

                                                
                                            </Grid2>
                                        </Grid2>
                                    ))}
                                </Grid2>
                            </Grid2>

                        </Box>
                    </Grid2>
                </Grid2>


                {rejectModal && (
                    <>
                        <div 
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 999,  // Make sure the overlay is below the modal
                            }}
                            onClick={onClose} // Close modal if clicked anywhere outside the modal
                        />
                        <div style={{
                            position: 'fixed', top:'4px', right:0, height:'100%',
                            width: '580px',
                            zIndex: 1000,
                            backgroundColor: '#F9F9F9',
                            padding: '2%',
                            height: '100vh',
                            borderRadius: '12px',
                        }}>
                            <IconButton
                                aria-label="close"
                                onClick={onClose}
                                style={{
                                    position: 'absolute',
                                    top: '-15px',
                                    left: '1px',
                                    color: '#333',
                                    zIndex: 10,
                                    paddingTop: '18px'
                                }}
                            >
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>

                            <Typography variant="body1" sx={{ color: '#4A4A4A', paddingTop: '6%', fontSize: '24px' }}>
                                Select Reason
                            </Typography>

                            <Grid2 style={{ maxWidth: '580px', margin: '0', backgroundColor: '#FFFFFF', borderRadius: '12px' }}>
                                <div style={{
                                    alignItems: 'center',
                                    backgroundColor: '#fff',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    marginTop: '30px'
                                }}>
                                    <Typography
                                        variant="body1"
                                        style={{
                                            color: '#1A1E25',
                                            fontWeight: '500',
                                            fontSize: '20px',
                                            paddingLeft: '4%'
                                        }}
                                    >
                                        Select Reason
                                    </Typography>

                                    <FormControl sx={{ marginLeft: '20px', marginTop: '2%' }}>
                                        <RadioGroup
                                            defaultValue=""
                                            name="controlled-radio-buttons-group"
                                            value={rejectValue}
                                            onChange={handleRejectChange}
                                        >
                                            <FormControlLabel sx={{ fontSize: '16px' }} value="Wrong Document" control={<Radio />} label="Wrong Document" />
                                            <FormControlLabel sx={{ fontSize: '16px' }} value="Image not clear" control={<Radio />} label="Image not clear" />
                                            <FormControlLabel sx={{ fontSize: '16px' }} value="other" control={<Radio />} label="Other" />
                                        </RadioGroup>
                                    </FormControl>

                                    <div style={{ marginLeft: '20px', marginTop: '18px' }}>
                                        <textarea
                                            name="Outlined"
                                            value={customReason}
                                            onChange={handleTextAreaChange}
                                            placeholder="Type in here…"
                                            style={{
                                                width: '90%',
                                                height: '100px',
                                                borderRadius: '8px',
                                                padding: '10px',
                                                borderColor: '#D1D5DB'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginTop: '18px', textAlign: 'center' }}>
                                        <Button
                                            variant='contained'
                                            className='actionButton'
                                            sx={{ ml: '4%', backgroundColor: '#C71F1F' }}
                                            onClick={() => {
                                                handleRejectSubmit(modalData.documentId, modalData.vehicleId, modalData.status, modalData.docType, customReason ? customReason : rejectValue);
                                                onClose(); // Close modal after rejection
                                            }}
                                            disabled={!customReason && !rejectValue}
                                        >
                                            Reject
                                        </Button>
                                    </div>

                                </div>
                            </Grid2>
                        </div>
                    </>
                )}
            </div>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={() => showSnackbar(false)} message={message}></Snackbar>
            
        </div>
    );
};

export default CustomerDetails;